module.exports = {"description":"","displayName":"NavBar","methods":[],"props":{"children":{"type":{"name":"node"},"required":false,"description":"Navigation bar content (NavItems)"},"cssMap":{"defaultValue":{"value":"require( './navBar.css' )","computed":true},"required":false}}}


//////////////////
// WEBPACK FOOTER
// ./.lochness/props/NavBar-props.json
// module id = 444
// module chunks = 0